import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useCoreContext } from '../../../../../utils/core/RPPCoreContext'
import { useCurrentAccountContext } from '../../../../../utils/current-account/CurrentAccountContext'
import { buildAdminRecentlyViewedStorageKey } from './recentlyViewed.types'
import { isAdminPath, resolveRoutePattern } from './recentlyViewed.utils'
import { recordAdminPageView } from './recentlyViewedStorage'

// Records a view for every admin page the user lands on. Mounted once in
// AdminSection so it observes navigation across all `/app/admin` routes. Renders
// nothing. Recorded views power the "Recently viewed" list on the admin
// homepage; only `/app/admin` pages are ever stored, scoped to the current
// admin identity.
export const AdminPageViewTracker = () => {
  const { pathname } = useLocation()
  const { routesByName } = useCoreContext()
  const identityId = useCurrentAccountContext()?.account?.canonicalId

  useEffect(() => {
    if (!isAdminPath(pathname)) return

    const storageKey = buildAdminRecentlyViewedStorageKey(identityId)
    const { key, routeName } = resolveRoutePattern(pathname, routesByName)
    // Fire-and-forget: tracking must never block or break navigation. Writes are
    // serialized inside recordAdminPageView so concurrent navigations don't race.
    void recordAdminPageView(storageKey, {
      key,
      path: pathname,
      routeName,
      viewedAt: Date.now(),
    }).catch(() => undefined)
  }, [pathname, routesByName, identityId])

  return null
}
